import { useEffect } from 'react';
import cookies from 'browser-cookies';
import { getIDmeRegistrationType, ID_ME_SIGNUP_TYPE_COOKIE_NAME, type IDMeRegistrationSignupType } from '../../utils';
export type IDmeSignupTypeCookieProps = {
  signupType: IDMeRegistrationSignupType | null;
};
export const IDmeSignupTypeCookie = ({
  signupType
}: IDmeSignupTypeCookieProps) => {
  useEffect(() => {
    const normalizedSignupType = getIDmeRegistrationType({
      signupType
    });
    if (!normalizedSignupType) return;
    cookies.set(ID_ME_SIGNUP_TYPE_COOKIE_NAME, normalizedSignupType, {
      domain: '.stitchfix.com',
      path: '/',
      secure: true
    });
  }, [signupType]);
  return null;
};